import { render, staticRenderFns } from "./DisclosureFooter.vue?vue&type=template&id=053b492e&scoped=true"
import script from "./DisclosureFooter.vue?vue&type=script&lang=js"
export * from "./DisclosureFooter.vue?vue&type=script&lang=js"
import style0 from "./DisclosureFooter.vue?vue&type=style&index=0&id=053b492e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053b492e",
  null
  
)

export default component.exports